'use es6';

import { List, Record } from 'immutable';
import Form from './Form';
import { RequestStatus } from '../constants/base';
const DEFAULTS = {
  forms: List(),
  status: RequestStatus.UNINITIALIZED
};
export default class Forms extends Record(DEFAULTS) {
  static fromJS(data) {
    return new Forms({
      forms: List(data).map(Form.fromJS),
      status: RequestStatus.SUCCEEDED
    });
  }
}